<template>
  <section class="item-education  w-100">
    <div class="row">
      <div class="col-12">
        <div class="information">
          <h3>{{ label }} : </h3> {{ showLabel(item) }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    props:{
      item : {},
      label: {},
    },
    data() {
      return {
        work : {
          position: 'Manager IT',
          company_name: 'Inibaru.id',
          location: 'Jawa Tengah',
          year_start : '2015',
          year_end : '2019',
          job_dask : '1. Leadership',
          skills : [
            'Social Media Marketing',
            'Social Media Marketing',
          ]
        },
        
      };
    },
    methods: {
      showLabel(item){
        let name = [];

        item.forEach(element => {
          name.push(element.name);
        });

        return name.join(" , ");
      }
    }
  };
</script>

<style lang="scss">
.item-education{
  align-self: baseline;
  padding: .7rem 1rem;
  border-left: 10px solid var(--theme-deafult);
  box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  .d-flex{
    gap: 10px;
  }
  .information{
    flex: 1;
    h3{
      font-size: 1rem;
      color: var(--theme-deafult);
    }

    h5{
      font-size: .8rem;
      font-weight: 400;
    }
  }

  .item-skill{
    flex: 1;
    h3{
      font-size: 0.8rem;
      font-weight: 500;
    }

    .d-flex{
      flex-wrap: wrap;

      h5{
        padding: 0.2rem 1rem;
        background: var(--theme-deafult);
        color: var(--theme-font);
        font-size: 0.6rem;
        border-radius: 1rem !important;
        margin-bottom: 0;
      }
    }
  }
}
</style>
